import produce, { Draft } from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { EmarketingSentState, initialState } from './model';

const emarketingSent = produce((draft: Draft<EmarketingSentState>, action: ActionType<typeof actions>) => {
  switch (action.type) {
    // emarketingSummary
    case getType(actions.emarketingSentSummary.request): {
      draft.summary.loading = true;
      return draft;
    }
    case getType(actions.emarketingSentSummary.success): {
      draft.summary.loading = false;
      draft.summary.response = action.payload;
      return draft;
    }
    case getType(actions.emarketingSentSummary.failure): {
      draft.summary.loading = false;
      draft.summary.response = action.payload;
      return draft;
    }
    // emarketingDetail
    case getType(actions.emarketingSentDetail.request): {
      draft.details.loading = true;
      return draft;
    }
    case getType(actions.emarketingSentDetail.success): {
      draft.details.loading = false;
      draft.details.response = action.payload;
      return draft;
    }
    case getType(actions.emarketingSentDetail.failure): {
      draft.details.loading = false;
      draft.details.errors = action.payload;
      return draft;
    }
    case getType(actions.deleteEmarketingSent.request): {
      draft.delete.loading = true;
      return draft;
    }
    case getType(actions.deleteEmarketingSent.success): {
      draft.delete.loading = false;
      draft.delete.response = action.payload;
      return draft;
    }
    case getType(actions.deleteEmarketingSent.failure): {
      draft.delete.loading = false;
      draft.delete.errors = action.payload;
      return draft;
    }
    case getType(actions.bulkEmarketingSents.request): {
      draft.bulk.loading = true;
      return draft;
    }
    case getType(actions.bulkEmarketingSents.success): {
      draft.bulk.loading = false;
      draft.bulk.response = action.payload;
      return draft;
    }
    case getType(actions.bulkEmarketingSents.failure): {
      draft.bulk.loading = false;
      draft.bulk.errors = action.payload;
      return draft;
    }
    // sendEmail
    case getType(actions.sendEmail.request): {
      draft.send.loading = true;
      return draft;
    }
    case getType(actions.sendEmail.success): {
      draft.send.loading = false;
      draft.send.response = action.payload;
      return draft;
    }
    case getType(actions.sendEmail.failure): {
      draft.send.loading = false;
      draft.send.errors = action.payload;
      return draft;
    }
    // getById
    case getType(actions.getEmarketingSentById.request): {
      draft.getById.loading = true;
      return draft;
    }
    case getType(actions.getEmarketingSentById.success): {
      draft.getById.loading = false;
      draft.getById.response = action.payload;
      return draft;
    }
    case getType(actions.getEmarketingSentById.failure): {
      draft.getById.loading = false;
      draft.getById.errors = action.payload;
      return draft;
    }

    // Clear
    case getType(actions.clearData): {
      if (action.payload) {
        // Handle clearing specific keys, including 'getById'
        if (action.payload === 'getById') {
          draft.getById = initialState.getById;
        } else if (action.payload === 'send') {
          draft.send = initialState.send;
        } else if (action.payload === 'summary') {
          draft.summary = initialState.summary;
        } else if (action.payload === 'details') {
          draft.details = initialState.details;
        } else if (action.payload === 'delete') {
          draft.delete = initialState.delete;
        } else if (action.payload === 'bulk') {
          draft.bulk = initialState.bulk;
        } else {
          (draft as any)[action.payload] = {};
        }
      } else {
        // Reset to initial state
        Object.keys(initialState).forEach((key) => {
          (draft as any)[key] = (initialState as any)[key];
        });
      }
      return draft;
    }
    default: {
      return draft;
    }
  }
}, initialState);

export default emarketingSent;
